export const FETCH_CHANNEL_GET_SUBSCRIBED_CHANNELS_REQUEST = 'FETCH_CHANNEL_GET_SUBSCRIBED_CHANNELS_REQUEST'
export const FETCH_CHANNEL_GET_SUBSCRIBED_CHANNELS_SUCCESS = 'FETCH_CHANNEL_GET_SUBSCRIBED_CHANNELS_SUCCESS'
export const FETCH_CHANNEL_GET_SUBSCRIBED_CHANNELS_FAILURE = 'FETCH_CHANNEL_GET_SUBSCRIBED_CHANNELS_FAILURE'
